export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null,
    status: null
  },
  actions: {
    success({ commit }, payload) {
      commit("success", payload);
    },
    error({ commit }, payload) {
      commit("error", payload);
    },
    clear({ commit }) {
      commit("clear");
    }
  },
  mutations: {
    success(state, payload) {
      state.type = "success";
      state.message = payload.message || payload.statusText;
      state.status = payload.status;
      state.url = payload.url;
    },
    error(state, payload) {
      state.type = "error";
      if (payload.Error) {
        state.message = payload.Error.Message;
        state.status = 500;
        state.url = payload.Path;
      } else {
        state.message = payload.message || payload.statusText;
        state.status = payload.status;
        state.url = payload.url;
      }
    },
    clear(state) {
      state.type = null;
      state.message = null;
      state.status = null;
      state.url = null;
    }
  }
};
